export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      required: true
    },
    bgColor: {
      type: String,
      required: false,
      default: () => "#001d38"
    },
    textColor: {
      type: String,
      required: false,
      default: () => "#FFFFFF"
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
};
